import { Box, Typography, Table, TableBody, TableCell, TableRow } from '@mui/material';

const Footer = ({ values, page }) => {
  const landlordName = values?.manager
    ? `${values.manager.first_name || ''} ${values.manager.last_name || ''}`.trim()
    : '';
  const landlordInitials = landlordName
    ? landlordName.split(' ').map((word) => word.charAt(0).toUpperCase()).join('')
    : 'N/A';

  // Adopted initials show only on pages the tenant initialed (records without
  // per-page data show them everywhere); legacy signed tenants fall back to
  // name-derived initials so old leases keep displaying as before.
  const tenantInitials =
    values?.tenants
      ?.map((tenant) => {
        const manual = (tenant.initials || '').trim();
        if (manual) {
          const pages = tenant.initialed_pages || [];
          return !pages.length || page == null || pages.includes(page) ? manual : '';
        }
        return tenant.signature && tenant.signature.trim() !== ''
          ? tenant.name
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase())
              .join('')
          : '';
      })
      ?.filter(Boolean)
      ?.join(', ') || '';

  return (
    <Box
      className="lease-form-footer"
      position="relative"
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      sx={{ mb: 2, minHeight: 60 }}
    >
      {/* Page Number - absolutely centered */}
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          textAlign: 'center',
        }}
      >
        <Typography variant="caption" fontSize="0.75rem">
          Page {page}
        </Typography>
      </Box>

      {/* Initials Section aligned to the right */}
      <Box display="flex" alignItems="center">
        <Box textAlign="center" mr={2}>
          <Typography variant="caption" fontSize="0.7rem">
            INITIALS
          </Typography>
        </Box>
        <Table
          size="small"
          sx={{ width: '120px', border: '1px solid', borderColor: 'grey.500' }}
        >
          <TableBody>
            <TableRow>
              <TableCell
                align="center"
                sx={{
                  borderRight: '1px solid',
                  borderColor: 'grey.500',
                  fontSize: '0.8rem',
                  p: 0.5,
                }}
              >
                Landlord
              </TableCell>
              <TableCell align="center" sx={{ fontSize: '0.8rem', p: 0.5 }}>
                Tenant(s)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                align="center"
                sx={{
                  borderRight: '1px solid',
                  borderColor: 'grey.500',
                  fontSize: '0.9rem',
                  p: 0.5,
                }}
              >
                {landlordInitials}
              </TableCell>
              <TableCell align="center" sx={{ fontSize: '0.9rem', p: 0.5 }}>
                {tenantInitials}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export { Footer };
